var React = require('react');

function ArrowOutlineRight (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M28.172 23L22.808 17.636L24.222 16.222L32 24L24.222 31.778L22.808 30.364L28.172 25H16V23H28.172Z","fill":"#5D44B7","key":0}),React.createElement("circle",{"cx":"24","cy":"24","r":"23","stroke":"#5D44B7","strokeWidth":"2","key":1})]);
}

ArrowOutlineRight.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = ArrowOutlineRight;

ArrowOutlineRight.default = ArrowOutlineRight;
